module.exports = __webpack_public_path__ + "static/media/11NEPAD8.c868240d.jpg";